import { websitePaths } from 'domains/website/website.paths'

import { AnalyticsIcon } from 'components/pages/@shared/icons/analytics'
import { BranchingIcon } from 'components/pages/@shared/icons/branching'
import { CliIcon } from 'components/pages/@shared/icons/cli'
import { EdgeCachingIcon } from 'components/pages/@shared/icons/edge-caching'
import { GlobeIcon } from 'components/pages/@shared/icons/globe'
import { ShieldCheckIcon } from 'components/pages/@shared/icons/shield-check'

export const features = [
  {
    name: 'Auth',
    href: websitePaths.auth,
    description: 'Seamless integration with your identity provider',
    icon: ShieldCheckIcon,
  },
  {
    name: 'CLI',
    href: websitePaths.cli,
    description: 'Zero config local development',
    icon: CliIcon,
  },
  {
    name: 'Edge Gateway',
    href: websitePaths.edgeGateway,
    description: 'Unified data layer at the edge',
    icon: GlobeIcon,
  },
  {
    name: 'Branching',
    href: websitePaths.branching,
    description:
      'Collaborate on backend changes with your team without the hassle',
    icon: BranchingIcon,
  },
  {
    name: 'Edge Caching',
    href: websitePaths.edgeCaching,
    description: 'Accelerate any API or database',
    icon: EdgeCachingIcon,
  },
  {
    name: 'Analytics',
    href: websitePaths.analytics,
    description: 'Realtime performance insights',
    icon: AnalyticsIcon,
  },
] as const
